
import { updateDiagramNodeLabels, getDiagramNodeLabels } from '@process-advisor/process-miner/processMiner/processMiner';

export type NodeLabelsProps = {
    tasks?: boolean;
    perc_total?: boolean;
}

export const changeNodeLabels = ({
    tasks,
    perc_total,
}: NodeLabelsProps) => updateDiagramNodeLabels({
    tasks,
    perc_total,
});

export const getNodeLabels = (): NodeLabelsProps => getDiagramNodeLabels();
